import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useRemarkForm from "./useRemarkForm";

const RemarkForm = ({ handleClose, handleYes }) => {
  const { formik } = useRemarkForm({ handleYes });

  return (
    <div>
      <h5 className="pro-ttl h5 pro-mb-4">Generate Estimate</h5>
      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="remark"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Remark<span className="pro-ms-1">*</span>
        </label>
        <textarea
          id="remark"
          rows={4}
          name="remark"
          className={`pro-input lg ${
            formik.errors.remark && formik.touched.remark && " error"
          }`}
          onChange={(e) => formik?.setFieldValue("remark", e.target.value)}
          onBlur={formik?.handleBlur("remark")}
          value={formik?.values?.remark}
        ></textarea>
        {formik.touched.remark && formik.errors.remark && (
          <span className="error-text">{formik.errors.remark}</span>
        )}
      </div>
      <div className={`col-12 pro-d-flex pro-justify-end pro-mt-2`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleClose}
          type="button"
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik?.handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default RemarkForm;
